module.exports = __webpack_public_path__ + "static/media/amusement(13).2aee8ece.PNG";